document.addEventListener("DOMContentLoaded", function () {
  initModals();
  initWarrantyOption();

  // Check if we are on the correct product page and initialize the functionality
  initializeProductPageFunctionality();
});

function initializeProductPageFunctionality() {
  const productHandle = window.location.pathname.split("/").pop();
  const productUrl = `/products/${productHandle}.json`;

  fetch(productUrl)
    .then((response) => response.json())
    .then((data) => {
      const productId = data.product.id;

      if (productId === 9604539220249) {
        setupCartObserver();
      } else {
        console.log("Not on the specified product page.");
      }
    })
    .catch((error) => {
      console.error("Error fetching product details:", error);
    });
}

function setupCartObserver() {
  const cartCountElement = document.querySelector("span[data-js-cart-count]");

  if (cartCountElement) {
    const observer = new MutationObserver(function (mutationsList) {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          const newCartCount = cartCountElement.textContent.trim();
          console.log("Cart count changed:", newCartCount);
          handleCartCountChange(newCartCount);
        }
      }
    });

    observer.observe(cartCountElement, { childList: true });

    function handleCartCountChange(cartCount) {
      const selectedWarrantyId =
        document.getElementById("selected-warranty").value;

      if (selectedWarrantyId) {
        addCustomItemById(selectedWarrantyId, 1)
          .then(() => {
            console.log("Warranty product added successfully");
            location.reload();
          })
          .catch((error) => {
            console.error("Error adding warranty product to cart:", error);
          });
      }
    }

    async function addCustomItemById(id, quantity) {
      let data = {
        items: [
          {
            id,
            quantity,
          },
        ],
      };
      return fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((res) => {
          if (res.status == "422") {
            throw new Error(res.description);
          }
          return res;
        });
    }
  } else {
    console.error("Cart count element not found.");
  }
}

function initWarrantyOption() {
  document.querySelectorAll(".warranty-option").forEach((option) => {
    option.addEventListener("click", function () {
      document
        .querySelectorAll(".warranty-option")
        .forEach((opt) => opt.classList.remove("selected"));
      this.classList.add("selected");
      document.getElementById("selected-warranty").value =
        this.getAttribute("data-warranty-id");
    });
  });
}

function getProductVariantId(productHandle) {
  return fetch(`/products/${productHandle}.json`)
    .then((response) => response.json())
    .then((data) => {
      if (data.product && data.product.variants.length > 0) {
        // Return the ID of the first variant
        return data.product.variants[0].id;
      } else {
        throw new Error("No variants found for product.");
      }
    });
}

function initModals() {
  // Initialize both modals
  setupModal({
    modalId: "fsa-modal",
    closeBtnId: "fsa-modal-closeBtn",
    triggerSelector: ".fsa-modal-trigger",
  });

  setupModal({
    modalId: "warranty-modal",
    closeBtnId: "warranty-modal-closeBtn",
    triggerSelector: ".warranty-modal-trigger",
  });

  function setupModal({ modalId, closeBtnId, triggerSelector }) {
    let modal = document.getElementById(modalId);
    let triggerElements = document.querySelectorAll(triggerSelector);
    let closeBtn = document.getElementById(closeBtnId);
    let scrollPosition = 0;

    function openModal() {
      scrollPosition = window.scrollY; // Save the current scroll position
      modal.showModal();
      document.body.classList.add("modal-open");
      document.body.style.top = `-${scrollPosition}px`; // Set the top to offset the scroll position
    }

    function closeModal() {
      modal.close();
      document.body.classList.remove("modal-open");
      document.body.style.top = ""; // Reset the top style
      window.scrollTo(0, scrollPosition); // Restore the scroll position
    }

    // Open the dialog when any trigger element is clicked
    triggerElements.forEach(function (element) {
      element.onclick = openModal;
    });

    // Close the dialog when the 'X' button is clicked
    closeBtn.onclick = closeModal;

    // Optional: Close the dialog when clicking outside of it
    modal.addEventListener("click", function (event) {
      if (event.target === modal) {
        closeModal();
      }
    });
  }
}

function initWarrantyOption() {
  document.querySelectorAll(".warranty-option").forEach((option) => {
    option.addEventListener("click", function () {
      document
        .querySelectorAll(".warranty-option")
        .forEach((opt) => opt.classList.remove("selected"));
      this.classList.add("selected");
      document.getElementById("selected-warranty").value =
        this.getAttribute("data-warranty-id");
    });
  });
}
